// ============================================================
// Sunucunun ürettiği bildirim kayıtları (docs/04 §4)
//
// İstemci bildirimleri veriden TÜRETİYOR (domain/notifications.js)
// ve bu, uygulama açıkken doğru çalışıyor. Ama türetme yalnızca
// açık uygulamada olur: veli sabah 09:30'da uygulamada değil.
// Zamanlanmış işler (functions/bildirimler.js) kalıcı kayıt
// üretiyor; burası onları okuyup zile taşıyor.
//
// BİRLEŞTİRME anahtar üzerinden. Sunucu kaydı istemcinin türettiği
// anahtarın AYNISINI taşıyor (key alanı), yani aynı olay zilde iki
// kez görünmüyor — biri türetilmiş biri kayıtlı olarak.
//
// Demo modda bu modül hiç çalışmaz: Firestore yok, türetme yeterli.
// ============================================================

import { firebaseHazir } from "../config.js";
import { state } from "../state.js";

// Şube kimliği → kayıt listesi. Açılışta bir kez dolar, okundu
// işaretlendiğinde yerinde güncellenir.
const kayitlar = new Map();

export const kayitliBildirimler = (branchId = state.branchId) =>
  kayitlar.get(branchId) ?? [];

/**
 * Kullanıcının eriştiği şubelerin bildirim kayıtlarını okur.
 *
 * Bir şubenin okuması reddedilirse (kural, ağ) diğerleri düşmez —
 * bildirim ikincil bir bilgi, yüzünden uygulama açılmamazlık
 * etmemeli.
 */
export async function kayitlariYukle({ tenantId, branchIds = [] } = {}) {
  kayitlar.clear();
  if (!firebaseHazir || !tenantId || !branchIds.length) return;

  const [{ initializeApp, getApps, getApp }, fs] = await Promise.all([
    import("firebase/app"),
    import("firebase/firestore"),
  ]);
  const { firebaseConfig } = await import("../config.js");
  const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
  const db = fs.getFirestore(app);

  await Promise.all(branchIds.map(async (bid) => {
    try {
      const anlik = await fs.getDocs(fs.query(
        fs.collection(db, `tenants/${tenantId}/branches/${bid}/notifications`),
        fs.orderBy("at", "desc"),
        fs.limit(100),
      ));
      kayitlar.set(bid, anlik.docs.map(d => ({ belgeId: d.id, ...d.data() })));
    } catch {
      kayitlar.set(bid, []);
    }
  }));
}

/** Kayıtları zilin beklediği şekle çevirir. */
export function kayitliBildirimListesi(branchId = state.branchId) {
  return kayitliBildirimler(branchId).map(k => ({
    key: k.key,
    tip: k.tur,
    baslik: k.baslik,
    metin: k.metin,
    onem: k.onem ?? "bilgi",
    kanallar: ["uygulama"],
    // Firestore Timestamp → ISO. Zil sıralamayı metin karşılaştırmasıyla
    // yaptığı için tarih string olmalı.
    at: k.at?.toDate ? k.at.toDate().toISOString() : (k.at ?? `${k.gun}T00:00`),
    hedef: "#/yoklama",
    studentId: k.studentId ?? null,
    // Kayıttan geldiğini işaretliyoruz: okundu yazımı Firestore'a
    // gitmeli, yalnızca yerel duruma değil.
    kayitli: true,
    belgeId: k.belgeId,
  }));
}

/**
 * Okundu işaretini Firestore'a yazar.
 *
 * Kurallar yalnızca okundu/okunduAt alanlarına izin veriyor; başka
 * bir alan gönderilirse yazma tamamen reddedilir.
 */
export async function kayitOkunduIsaretle(branchId, belgeId) {
  if (!firebaseHazir || !belgeId) return;

  const [{ getApps, getApp }, fs] = await Promise.all([
    import("firebase/app"),
    import("firebase/firestore"),
  ]);
  const db = fs.getFirestore(getApps().length ? getApp() : undefined);

  try {
    await fs.updateDoc(
      fs.doc(db, `tenants/${state.tenantId}/branches/${branchId}/notifications/${belgeId}`),
      { okundu: true, okunduAt: new Date().toISOString() },
    );
    const liste = kayitlar.get(branchId) ?? [];
    const k = liste.find(x => x.belgeId === belgeId);
    if (k) k.okundu = true;
  } catch {
    // Okundu işareti kritik değil; yazılamazsa yerel durum yeterli.
  }
}
